// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"aa7931d9","568":"207bb056"}[chunkId] + ".chunk.css";
};